import {
  GET_FILE_TOKEN_REQUEST,
  GET_FILE_TOKEN_SUCCESS,
  GET_FILE_TOKEN_FAILURE,
  CLEAR_TOKEN_RESPONSE,
} from "../actionTypes";

const intialState = {
  loading: false,
  token: [],
  error: "",
};

const fileTokenReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_FILE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FILE_TOKEN_SUCCESS:
      return {
        loading: false,
        token: action.payload,
        error: "",
      };
    case CLEAR_TOKEN_RESPONSE:
      return {
        loading: false,
        token: [],
        error: "",
      };

    case GET_FILE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        token: [],
        error: action.payload,
      };

    default:
      return state;
  }
};
export default fileTokenReducer;
